<template>
  <div class="c c-dealers">
    <DealerModule
      assets-folder="/assets/images/dealers"
      api-url=""
      api-key="AIzaSyC-WxAc-z9q7w6mjDM_gVC5hrBxyov5Nj8"
      :translations-url="`/umbraco/api/translations/getalltranslations?locale=${settings.culture}&dictionaryKey=Dealers`"
      :culture="settings.culture"
      number-of-results="50"
      :show-filters="false"
    >
      <template #searchButton="searchButton">
        <button
          id="searchform"
          class="btn btn-primary dm-searchform__button"
          type="button"
          @click="
            (searchButton.search(searchButton.localSearchTerm),
            trackDealerSearch(searchButton.localSearchTerm))
          "
        >
          <i class="far fa-search" />
        </button>
      </template>

      <template #filterButton="filterButton">
        <div class="dm-filter__button" @click="filterButton.toggleFilters">
          <i class="far fa-chevron-down" />
          <span class="font-weight-bold ml-3 pl-0">{{
            filterButton.translations.FilterTitle
          }}</span>
        </div>
      </template>

      <template #filterItem="filterItem">
        <div
          v-for="category in filterItem.allCategories"
          :key="category.Id"
          class="dm-filter__item"
        >
          <div class="custom-control custom-checkbox flex-grow">
            <input
              :id="'filter' + category.CodeName"
              v-model="filterItem.selectedFilters"
              type="checkbox"
              class="custom-control-input"
              :value="category.CodeName"
              @change="filterItem.changeFilter(category.CodeName)"
            />
            <label
              class="custom-control-label d-flex align-items-center"
              :for="'filter' + category.CodeName"
            >
              <span>{{ category.DisplayName }}</span>
            </label>
          </div>
          <div
            v-if="category.Tooltip !== null"
            class="dm-tooltip"
            :class="{ open: filterItem.openTooltip }"
          >
            <div class="dm-tooltip__button" @click="filterItem.toggleTooltip()">
              <i class="far fa-info-circle text-primary font-size-lg" />
            </div>
            <div class="dm-tooltip__body">
              {{ category.Tooltip }}
            </div>
          </div>
        </div>
      </template>

      <template #filterPostText="filterPostText">
        <div
          v-if="filterPostText.translations.FilterPostText != null"
          class="dm-filter__post"
          v-html="filterPostText.translations.FilterPostText"
        />
      </template>

      <template #results="results">
        <div class="dm-results__items">
          <div
            v-for="dealer in results.foundDealers"
            :key="dealer.Id"
            class="dm-result"
            @click="results.selectDealer(dealer)"
          >
            <div class="dm-result__distance mr-4">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 384 512"
                width="30px"
                class="text-primary"
              >
                <path
                  fill="currentColor"
                  d="M168.3 499.2C116.1 435 0 279.4 0 192C0 85.96 85.96 0 192 0C298 0 384 85.96 384 192C384 279.4 267 435 215.7 499.2C203.4 514.5 180.6 514.5 168.3 499.2H168.3zM192 256C227.3 256 256 227.3 256 192C256 156.7 227.3 128 192 128C156.7 128 128 156.7 128 192C128 227.3 156.7 256 192 256z"
                />
              </svg>
              <span
                v-if="
                  typeof dealer.Distance === 'number' && dealer.Distance >= 0
                "
                class="font-size-xs"
              >
                {{ dealer.Distance }}
                {{ results.translations.Kilometers }}
              </span>
            </div>
            <div class="dm-result__info pl-0">
              <strong>{{ dealer.Name }}</strong
              ><br />
              {{ dealer.Address }}<br />
              <span v-if="dealer.Address2 != null && dealer.Address2 != ''">
                {{ dealer.Address2 }}<br />
              </span>
              <span v-if="dealer.Postalcode != null && dealer.Postalcode != ''">
                {{ dealer.Postalcode }}<br />
              </span>
              {{ dealer.City }} <br />
              {{ dealer.Country }}
            </div>
          </div>
        </div>
      </template>

      <template #resultOverlay="resultOverlay">
        <div
          class="dm-resultoverlay__button"
          @click="resultOverlay.clearActiveDealer()"
        >
          <i class="far fa-arrow-left mr-2" />
          <span>{{ resultOverlay.translations.Back }}</span>
        </div>
        <div class="dm-resultoverlay__body">
          <div class="dm-resultoverlay__label">
            <span
              v-if="resultOverlay.activeDealer.Categories[0]"
              :class="
                'badge badge-secondary badge-' +
                resultOverlay.activeDealer.Categories[0].CodeName
              "
            >
              {{ resultOverlay.activeDealer.Categories[0].DisplayName }}
            </span>
          </div>
          <div v-if="resultOverlay.activeDealer.Logo">
            <img
              class="dm-resultoverlay__logo"
              :src="resultOverlay.activeDealer.Logo"
              :alt="resultOverlay.activeDealer.Name"
            />
          </div>

          <div class="dm-resultoverlay__title">
            <a
              v-if="resultOverlay.activeDealer.Link"
              :href="resultOverlay.activeDealer.Link"
              :title="resultOverlay.activeDealer.Name"
              class="text-decoration-none"
            >
              {{ resultOverlay.activeDealer.Name }}
            </a>

            <span v-else>
              {{ resultOverlay.activeDealer.Name }}
            </span>
          </div>
          <div class="dm-resultoverlay__info mb-3">
            <div>{{ resultOverlay.activeDealer.Address }}</div>
            <div
              v-if="
                resultOverlay.activeDealer.Address2 != null &&
                resultOverlay.activeDealer.Address2 != ''
              "
            >
              {{ resultOverlay.activeDealer.Address2 }}<br />
            </div>
            <div>
              {{ resultOverlay.activeDealer.Postalcode }}
              {{ resultOverlay.activeDealer.City }}
            </div>
            <div>{{ resultOverlay.activeDealer.Country }}</div>
          </div>

          <a
            v-if="
              resultOverlay.activeDealer.Phone != '' &&
              resultOverlay.activeDealer.Phone != null
            "
            :href="'tel:' + resultOverlay.activeDealer.Phone"
            target="_blank"
            class="dm-resultoverlay__phone text-decoration-none mb-1"
            @click="trackPhoneClick(resultOverlay.activeDealer)"
          >
            <i class="far fa-phone" />
            <span class="ml-2">{{ resultOverlay.activeDealer.Phone }}</span>
          </a>
          <a
            v-if="
              resultOverlay.activeDealer.EmailAddress &&
              resultOverlay.activeDealer.EmailAddress !== ''
            "
            :href="'mailto:' + resultOverlay.activeDealer.EmailAddress"
            target="_blank"
            class="dm-resultoverlay__email text-decoration-none mb-1"
            @click="trackMailClick(resultOverlay.activeDealer)"
          >
            <i class="far fa-envelope" />
            <span class="ml-2">{{
              resultOverlay.activeDealer.EmailAddress
            }}</span>
          </a>
          <a
            v-if="
              resultOverlay.activeDealer.Website &&
              resultOverlay.activeDealer.Website !== ''
            "
            :href="resultOverlay.activeDealer.Website"
            target="_blank"
            class="dm-resultoverlay__website text-decoration-none"
            @click="trackWebsiteClick(resultOverlay.activeDealer)"
          >
            <i class="far fa-globe" />
            <span class="ml-2">{{
              resultOverlay.translations.VisitWebsite
            }}</span>
          </a>
          <a
            v-if="
              resultOverlay.activeDealer.Link &&
              resultOverlay.activeDealer.Link !== ''
            "
            :href="resultOverlay.activeDealer.Link"
            class="dm-resultoverlay__website text-decoration-none"
          >
            <i class="far fa-arrow-right" />
            <span class="ml-2">{{ resultOverlay.translations.Link }}</span>
          </a>
          <a
            :href="
              'https://www.google.com/maps/dir//' +
              resultOverlay.activeDealer.Address.replace(' ', '+') +
              '+' +
              resultOverlay.activeDealer.Postalcode.replace(' ', '+') +
              '+' +
              resultOverlay.activeDealer.City.replace(' ', '+') +
              '/@' +
              resultOverlay.activeDealer.Position.Lat +
              ',' +
              resultOverlay.activeDealer.Position.Lng
            "
            target="_blank"
            class="dm-resultoverlay__route text-decoration-none"
          >
            <i class="far fa-route" />
            <span class="ml-2">{{
              resultOverlay.translations.RoutePlanner
            }}</span>
          </a>
        </div>
      </template>
    </DealerModule>
  </div>
</template>

<script>
import DealerModule from '../package/DealerModule.vue';

export default {
  components: {
    DealerModule
  },
  props: {
    settings: {
      type: Object,
      required: true
    }
  },
  methods: {
    trackPhoneClick(dealer) {
      this.$gtm.trackEvent({
        event: 'dealer-locator-phone',
        category: 'Dealer locator',
        action: 'Click phone number',
        label: `Dealer locator detail - ${dealer.Name}`
      });
    },
    trackMailClick(dealer) {
      this.$gtm.trackEvent({
        event: 'dealer-locator-email',
        category: 'Dealer locator',
        action: 'Click mail',
        label: `Dealer locator detail - ${dealer.Name}`
      });
    },
    trackWebsiteClick(dealer) {
      this.$gtm.trackEvent({
        event: 'dealer-locator-website',
        category: 'Dealer locator',
        action: 'Click website',
        label: `Dealer locator detail - ${dealer.Name}`
      });
    },
    trackDealerSearch(query) {
      this.$gtm.trackEvent({
        event: 'dealer-locator-searched',
        category: 'Dealer locator',
        action: 'Searched for dealer',
        label: query
      });
    }
  }
};
</script>

<style lang="scss">
@import '@/css/src/utilities/_variables.scss';

.dm {
  height: 60vh;
  overflow: hidden;

  .dm-sidebar {
    background: $light;
    box-shadow: $box-shadow;
    z-index: 10;
    border-right: none;
  }

  .dm-searchform {
    .form-control {
      background-color: $white;
    }

    &__button {
      padding: 16px 15px;
    }
  }

  .dm-resultoverlay {
    &__button {
      width: max-content;
      padding: inherit 30px;
      background-color: $body-color;
      color: $white;

      &:hover {
        background-color: $body-color;
        color: $white;
      }
    }

    &__logo {
      max-width: 175px;
      margin-bottom: 30px;
    }
  }
}
</style>
